<template>
  <div>
    <HAppFormComponent />
    <v-card class="mx-auto" width="256" tile>
      <v-navigation-drawer permanent>
        <div class="text-center" style="padding-top: 20px;">
          <v-menu rounded="lg" offset-x dark>
            <template v-slot:activator="{ on: menu, attrs }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-chip
                    class="ma-2"
                    color="lime darken-2"
                    text-color="white"
                    v-bind="attrs"
                    v-on="{ ...tooltip, ...menu }"
                  >
                    <v-avatar left>
                      <v-icon small>mdi-office-building-marker-outline</v-icon>
                    </v-avatar>
                    <strong>hApps</strong> Elements
                  </v-chip>
                </template>
                <span>Click to see options</span>
              </v-tooltip>
            </template>
            <v-list>
              <v-list-item dense>
                <v-list-item-title @click="openDialogForm">
                  <button>
                    <v-avatar left>
                      <v-icon small>mdi-office-building-marker-outline</v-icon>
                    </v-avatar>
                    <span>New hApp</span>
                  </button>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-divider></v-divider>
        <v-list nav dense>
          <v-list-item-group v-model="itemHApp" color="lime accent-2">
            <v-virtual-scroll
              :bench="benchedHApps"
              :items="listHApps"
              height="300"
              item-height="40"
              class="dark"
            >
              <template v-slot="{ item }">
                <HAppComponent :hApp="item" />
              </template>
            </v-virtual-scroll>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-card>
    <br />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { EventBus } from '@/js/EventBus.js'

import HAppComponent from '@/components/HApp/HApp'
import HAppFormComponent from '@/components/HApp/Form'

export default {
  name: 'hAppsComponent',
  components: {
    HAppComponent,
    HAppFormComponent
  },
  data () {
    return {
      benchedHApps: 0,
      listHApps: [],
      itemHApp: null
    }
  },
  props: {
    hApps: {
      required: true,
      type: Array,
      default: []
    }
  },
  mounted: function () {
    for (let key in this.hApps) {
      this.listHApps.push({ text: key, value: key })
    }

    this.listHApps = this.listHApps.map(({ value }) => {
      const content = JSON.parse(JSON.stringify(this.hApps[value]))
      return content
    })

    this.benchedHApps = this.listHApps.length

    EventBus.$on('NewHApp', hApp => {
      this.listHApps.push(hApp)
    })

  },
  methods: {
    openDialogForm () {
      EventBus.$emit('dialogFormHApp', true)
      EventBus.$emit('typeFormHApp', false)
    }
  }
}
</script>

<style scoped>
.v-card {
  background-color: rgba(0, 0, 0, 0.4);
  color: #f9fbe7;
  border: 1px solid #626f76;
  margin-bottom: 0.2rem;
}

.v-navigation-drawer {
  background-color: rgba(0, 0, 0, 0) !important;
}

.v-list {
  background-color: rgba(0, 0, 0, 0.4) !important;
}

.dark {
  scrollbar-width: thin;
  scrollbar-color: #3e3e3e #202020;
}

.dark::-webkit-scrollbar {
  width: 15px;
}

.dark::-webkit-scrollbar-track {
  background: #202020;
  border-left: 1px solid #2c2c2c;
}

.dark::-webkit-scrollbar-thumb {
  background: #3e3e3e;
  border: solid 3px #202020;
  border-radius: 7px;
}

.dark::-webkit-scrollbar-thumb:hover {
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/HApp/Index.vue